"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RechargeOptionInitRequest = void 0;
var RechargeOptionInitRequest = /** @class */ (function () {
    function RechargeOptionInitRequest() {
    }
    return RechargeOptionInitRequest;
}());
exports.RechargeOptionInitRequest = RechargeOptionInitRequest;
;
//# sourceMappingURL=rechargeOptionInit.request.js.map